import { render } from "./HeaderNotice.vue?vue&type=template&id=f2ecfd3e&scoped=true"
import script from "./HeaderNotice.vue?vue&type=script&lang=js"
export * from "./HeaderNotice.vue?vue&type=script&lang=js"

import "./HeaderNotice.vue?vue&type=style&index=0&id=f2ecfd3e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2ecfd3e"]])

export default __exports__